export const DAY_MS = 24 * 60 * 60 * 1000;

export const toTime = (date: string) => Date.parse(`${date}T00:00:00Z`);

/** Every month the range touches, as "YYYY-MM", with how many of its days fall inside the range (both ends included). */
export const getMonthSpans = ({ from, to }: { from: string; to: string }) => {
  const spans: { month: string; days: number }[] = [];
  const end = toTime(to) + DAY_MS;
  let cursor = toTime(from);
  while (cursor < end) {
    const start = new Date(cursor);
    const nextMonth = Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 1, 1);
    const monthEnd = Math.min(nextMonth, end);
    spans.push({ month: start.toISOString().slice(0, 7), days: Math.round((monthEnd - cursor) / DAY_MS) });
    cursor = monthEnd;
  }
  return spans;
};

// Sentinel-2 surface reflectance covers Europe from 2017, and nothing exists after today.
const FIRST_SATELLITE_DAY = "2017-01-01";

export const toDay = (time: number) => new Date(time).toISOString().slice(0, 10);
const shiftYears = (date: string, years: number) => `${Number(date.slice(0, 4)) + years}${date.slice(4)}`;
const earliest = (a: string, b: string) => (a < b ? a : b);
const latest = (a: string, b: string) => (a > b ? a : b);

/** A season's chart: January of the season year to the end of March of the next, but never past today. */
export const getSeasonRange = (seasonYear: number, today: string) => ({ from: `${seasonYear}-01-01`, to: earliest(`${seasonYear + 1}-03-31`, today) });

/** The year before a range, up to the day before it starts. Null once 2017 is reached. */
export const getYearBefore = ({ from }: { from: string }) =>
  from > FIRST_SATELLITE_DAY ? { from: latest(shiftYears(from, -1), FIRST_SATELLITE_DAY), to: toDay(toTime(from) - DAY_MS) } : null;

/** The year after a range, from the day after it ends. Null once today is reached. */
export const getYearAfter = ({ to }: { to: string }, today: string) =>
  to < today ? { from: toDay(toTime(to) + DAY_MS), to: earliest(shiftYears(to, 1), today) } : null;
